<template>
    <div>
        <van-search
                v-model="value"
                placeholder="请输入手机号码"
                show-action
                shape="round"
                @search="onSearch"
        >
            <div slot="action" @click="onSearch">查询</div>
        </van-search>

        <van-cell-group>

            <van-cell v-for="item,index in list" :key="index" @click="onCertificate(item.OrderNo)" :title="item.Name" value="查看证书" :label="item.CertNo" is-link />

        </van-cell-group>
    </div>
</template>

<script>
    export default {
        name: "SearchCert",
        data(){

            return{
                id:'',
                value:'',
                list:[],
            }
        },

        created(){


            this.id = this.$route.query.id||1;

            let key = localStorage.getItem('searchInfo')

            if(key){

                this.value=key;
                this.getData(key)

            }

        },

    methods:{

        onSearch(){


            this.getData(this.value);


        },

        getData(value){

            this.$http.get('/GZFPOneMeters/GetOrderByPhone',{Phone:value,ActivityId: this.id}).then(res=>{


                if(res.data.code===200){
                    this.list = res.data.data;


                    localStorage.setItem("searchInfo",this.value)
                }else {

                    this.$toast(res.data.message)
                }


            }).catch(err=>{

                this.$toast('查询证书出错')
            })

        },
        onCertificate(orderNo){


            if(orderNo){
                this.$router.push({path:'/certificate',query:{orderNo:orderNo,id:this.id}})
            }else {

                this.$toast('订单号不存在')
            }


        },
    }
    }
</script>

<style scoped>

</style>